angular
    .module('vppApp')
    .directive('swapVideo', function() {
        return {
            restrict: 'A',
            link: function(scope, elem, attrs) {
                elem.bind('click', function() {                     
                    // clicked element video url
                    var bcURL = elem[0].attributes['data-video-url'].value;
                    var title = elem[0].children[1].children[0].innerHTML;
                    var copy = elem[0].children[1].children[1].innerHTML;


                    // set the video player url to the clicked on
                    var videoplayer = document.getElementById('video-js');
                    videoplayer.setAttribute("src", bcURL);


                    // get the featured discription and title.
                    var featured_discription = document.getElementsByClassName("video-featured-desc");
                    var featured_title = featured_discription[0].children[0];
                    var featured_copy = featured_discription[0].children[1];

                    // get the featured discription and title.
                    featured_title.innerHTML = title;
                    featured_copy.innerHTML = copy;

                    //videoplayer.focus();

                    window.scrollTo(0, 0);
                });
            }
        };
    });
